'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M261.8 2.1l-5.5-5.1-5.5 5.1-240 224-5.8 5.5 10.9 11.7c.4-.4 11.2-10.5 32.4-30.2l0 298.9 416 0 0-298.9 26.5 24.8 5.8 5.5 10.9-11.7-5.8-5.5-37.5-35 0-159.2-96 0 0 69.6-106.5-99.4zm186.5 196l0 297.9-112 0 0-176-160 0 0 176-112 0 0-297.9 192-179.2 192 179.2zM192.3 496l0-160 128 0 0 160-128 0zm256-448l0 128.3-64-59.7 0-68.5 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;